export const AxisChartColours = (numberOfColors) => {
  //   Get Ryan to pick the colors
  const listOfColours = [
    "#00005F",
    "#EEEFEF",
    "#0C8",
    "#F36",
    "#FF8C00",
    "rgb(200, 20, 86)",
    "rgb(150, 50, 32)",
    "rgb(54, 62, 235)",
    "rgb(25, 25, 6)",
  ];

  return listOfColours.slice(0, numberOfColors);
};
